import { CartItemRemoveButton } from "./CartItemRemoveButton";
interface CartItemDetailsProps {
  name: string;
  subtitle: string;
  size?: string;
  color?: string;
  onRemove: () => void;
}
export const CartItemDetails = ({ name, subtitle, size, color, onRemove }: CartItemDetailsProps) => {
  return (
    <div className="flex justify-between items-start">
      <div className="flex-1">
        <h3 className="font-semibold text-black text-sm">{name}</h3>
        <p className="text-xs text-gray-600">{subtitle}</p>
        {(size || color) && (
          <div className="flex gap-2 mt-1">
            {size && (
              <span className="text-xs text-gray-500">Size: {size}</span>
            )}
            {color && (
              <span className="text-xs text-gray-500">Color: {color}</span>
            )}
          </div>
        )}
      </div>
      
      {/* Remove Button */}
      <CartItemRemoveButton onRemove={onRemove} />
    </div>
  );
};